export const RESTRICTIONS_GET_ALL = 'RESTRICTIONS_GET_ALL'
export const SET_SELECTED_RESTRICTION = 'SET_SELECTED_RESTRICTION'
export const CREATE_RESTRICTION = 'CREATE_RESTRICTION'
export const SAVE_RESTRICTION = 'SAVE_RESTRICTION'
export const DELETE_RESTRICTION = 'DELETE_RESTRICTION'




// WEBPACK FOOTER //
// ./src/store/modules/restrictions/mutation-types.js